import classNames from "classnames";
import imgCircleClose from "~/assets/images/icons/circle-close.svg";

export function SearchCloseButton({ onClick }: { onClick?: (e: any) => void }) {
  return (
    <button
      type="button"
      className={classNames(
        "tw:!absolute tw:!right-3 tw:!top-[50%] tw:!-translate-y-[50%] tw:!transition-colors",
        "tw:!text-night-sky-800 tw:hover:!text-blue-500 tw:!bg-transparent tw:!cursor-pointer tw:!border-0",
      )}
      onClick={onClick}
    >
      <img src={imgCircleClose} alt="close" width={16} height={16} />
    </button>
  );
}
